var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "passed_step",
  "use": "passed_step-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"passed_step\">\n<rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#9EFF22\" />\n<path d=\"M8.36365 12.4546L10.6364 14.7273L15.6364 9.72729\" stroke=\"black\" stroke-opacity=\"0.9\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol